import { OPEN_TRIP_STATUSES } from '@chukua/common';

/** From dispatch until the driver's part is done: `assigned` has not been sent to the driver yet, and an aborted or closed trip takes no more steps. The server decides; this only hides the panel. */
const CAPTURE_STATUSES = OPEN_TRIP_STATUSES.filter((status) => status !== 'assigned');

export function canOfferDriverCapture(input: { tripStatus: string; hasDriver: boolean; canDispatch: boolean }): boolean {
  return input.canDispatch && input.hasDriver && (CAPTURE_STATUSES as readonly string[]).includes(input.tripStatus);
}
